Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.YoutubeContent(socialContent)
    content.set({ possibleTags: allTags })
    return content

  canHandle: (socialContent) ->
    return socialContent.group_type == 'inbox' and socialContent.data and (socialContent.data.proper_type == 'youtube' || socialContent.data.type == 'youtube')
